import * as types from 'actions/actionTypes';

export function SaveRowIndex(index){
    return {type: types.GRID_SAVEROWINDEX, data: index}
}

export function ClearRowIndex(){
    return {type: types.GRID_SAVEROWINDEX, data: 0 }
}


// WEBPACK FOOTER //
// ./src/actions/gridActions.js